import { render } from "./AIFeaturesSection.vue?vue&type=template&id=e7aea8c0&scoped=true"
import script from "./AIFeaturesSection.vue?vue&type=script&lang=js"
export * from "./AIFeaturesSection.vue?vue&type=script&lang=js"

import "./AIFeaturesSection.vue?vue&type=style&index=0&id=e7aea8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7aea8c0"]])

export default __exports__